import { SignIn } from '@clerk/clerk-react';

export function SignInPage() {
  return (
    <main className="page page-centered">
      <SignIn signUpUrl="/sign-up" forceRedirectUrl="/dashboard" />
    </main>
  );
}
